import React, { useState, useEffect,useRef,cloneElement } from 'react';
import { Modal, Space, Button } from 'antd';
import { useNotificationListTemplate } from 'hooks/notification/notificationList';
import SPCountDownButton from '../../base/SPCountDownButton'
import SPButton from '../../carRental/base/SPButton'
import './style.css'

import emiter, {_EVENTS } from '../../../events'

import moment from 'moment'


interface props {
  permission?:any
}

interface htmlProps {
  data: any
}

const HtmlDomRender: React.FC<htmlProps> = (props: any) => {

  const { data } = props
  const [htmlData, setHtmlData] = useState<any>(data)

  return <div dangerouslySetInnerHTML={{ __html: htmlData}} style={{overflow:'hidden',overflowX: 'auto'}} className='richContent'></div>
}

const SPGlobalNotification: React.FC<props> = (props) => {
  const { permission } = props

  const { search, readLater, update } = useNotificationListTemplate();


  const openNotificationModel = async () => {
		const res = await search({
      read_status: -1,
      type: -1,
      channels: '4',
      page: 1,
      page_size: 1000
    })
    // const list = res?.data?.list || []
    const list: any = []
    res.data.list && res.data.list.map((item: any) => {
      if (item.channel == 4) {
        list.push(item)
      }
    })
    const item = list && list.find((item: any) => item.read_status == "未读" && moment(item.end_time).isAfter(moment()));
        if (item) {
					const modal = Modal.confirm({
						title: item.title,
                        icon: null,
                        width:1000,
                        content: (
                            <div>
                                <p>{item.brief}</p>
                                <HtmlDomRender data={item.content}></HtmlDomRender>
                                <Space style={{display:'flex',justifyContent:'end'}}>
                                    <Button onClick={() => {
                                      // readLater(item).then((res:any)=>{
                                      //   if (res.errno == 0) {
                                          modal.destroy()
                                          // openNotificationModel()
                                          // }
                                        // })
                                    }} >稍后阅读</Button>
                                    <SPCountDownButton onClick={() => {
                                      update(item).then((res:any)=>{
                                        if (res.errno == 0) {
                                            modal.destroy()
                                            openNotificationModel()
                                            emiter.emit(_EVENTS.NOTIFICATION.NOTIFICATION_LIST.SEARCH, {});
                                          }
                                        })
                                    }} disabled={true} countDownTime={item.count_down}></SPCountDownButton>
                                </Space>
                            </div>
                        ),
						okButtonProps: { style: { display: 'none' } },
						cancelButtonProps: { style: { display: 'none' } }
					});
		}
	};


  useEffect(() => {
    openNotificationModel()
  }, [])

  const [isScrolle, setIsScrolle] = useState(true) //控制是否滚动
  const [context, setContext] = useState([]) //滚动消息
  const speed = 50 //滚动速度，值越小，滚动越快
  const warper: any = useRef<any>() //对应parent的节点
  const childDomInit: any = useRef() //初始的消息节点
  const childDomCopy: any = useRef() //复制的消息节点

  const getTopMsg = () => {
    search({
      read_status: -1,
      type: -1,
      channels: '5',
      page: 1,
      page_size: 1000
    }).then((res) => {
      let arr: any = []
      res.data.list && res.data.list.map((item: any) => {
        if (item.channel == 5 && moment(item.end_time).isAfter(moment())) {
          arr.push(item)
        }
      })
      setContext(arr)
      context.length > 0 && copyDom()
    })
  }

  useEffect(() => {
    getTopMsg()
    emiter.on(_EVENTS.NOTIFICATION.NOTIFICATION_LIST.TOPMSG, getTopMsg);
    return () => {
      emiter.removeAllListeners(_EVENTS.NOTIFICATION.NOTIFICATION_LIST.TOPMSG)
    }
  },[])

 // 开始滚动
  useEffect(() => {
    let timer : any
    if (isScrolle) {
      timer = setInterval(() => {
        warper.current.scrollLeft >= childDomInit.current.scrollWidth
          ? (warper.current.scrollLeft = 0)
          : warper.current.scrollLeft++
      }, speed)
    }
    return () => {
      clearTimeout(timer)
    }
  }, [isScrolle])

  const copyDom = () => {
    if (context.length>0 && (warper.current.offsetWidth <= childDomInit.current.scrollWidth)) {
      childDomCopy.current.innerHTML = ''
          const htmlStructures = Array.from(childDomInit.current.children);
          htmlStructures.forEach((structure:any,index:any) => {
            const clonedElement = structure.cloneNode(true);
            clonedElement.addEventListener('click', () => onClickScrolle(index));
            clonedElement.addEventListener('mouseover', () => hoverHandler(false));
            clonedElement.addEventListener('mouseleave', () => hoverHandler(true));
            childDomCopy.current.appendChild(clonedElement);
          });
        }
  }

  useEffect(() => {
    copyDom()
  },[context])


// 鼠标移动，移除方法
  const hoverHandler = (flag: any) => setIsScrolle(flag)



  const onClickScrolle = (index: any) => {
    let msg: any = context[index]
    const modal = Modal.confirm({
						title: msg.title,
            icon: null,
            width:1000,
            content: (
                            <div>
                                <p>{msg.brief}</p>
                                <HtmlDomRender data={msg.content}></HtmlDomRender>
                                <Space style={{display:'flex',justifyContent:'end'}}>
                                  {msg.read_status == '未读' ?<>
                                    <Button onClick={() => {
                                        // readLater(msg).then((res:any)=>{
                                        // if (res.errno == 0) {
                                          modal.destroy()
                                          // }
                                        // })
                                    }}>稍后阅读</Button>
                                    <SPCountDownButton onClick={() => {
                                        update(msg).then((res:any)=>{
                                        if (res.errno == 0) {
                                            modal.destroy()
                                            emiter.emit(_EVENTS.NOTIFICATION.NOTIFICATION_LIST.SEARCH, {});
                                            emiter.emit(_EVENTS.NOTIFICATION.NOTIFICATION_LIST.TOPMSG);
                                          }
                                        })
                                    }} disabled={true} countDownTime={msg.count_down}></SPCountDownButton></> : <Button onClick={()=>{modal.destroy()}}>关闭</Button>}
                                </Space>
                            </div>
                        ),
						okButtonProps: { style: { display: 'none' } },
						cancelButtonProps: { style: { display: 'none' } }
					});
  }

    return (
      < >
        {context.length > 0 && <div className="parent" ref={warper} style={{ marginBottom: '20px' }}>
          <div className="child" ref={childDomInit}>
            {context?.map((item: any, index) => (
              <span
                key={index}
                onMouseOver={() => hoverHandler(false)}
                onMouseLeave={() => hoverHandler(true)}
                onClick={() => onClickScrolle(index)}
              >
                <span style={{ fontSize: '16px', marginLeft: 10 }}>（{index + 1}）</span>
                {item.title}：
                {item.brief}
              </span>
            ))}
          </div>
          <div className="child" ref={childDomCopy}></div>
        </div>}
      </>
    )
}

export default SPGlobalNotification
